// components/common/ItemOption.jsx
// Shared item-picker dropdown option, so every "add / filter item" typeahead
// shows the same merchant-facing identity as the grids: a thumbnail + product
// name + SKU on image-capable (Shopify) stores, the real item_code + name
// otherwise. The plain-text INPUT label lives in utils/itemLabel.formatItemLabel
// (single source of truth for the label string); this is the LIST rendering.

import ProductIdentity from '../grid/ProductIdentityView';
import { formatItemLabel } from '../../utils/itemLabel';
import './ItemOption.css';

// Dropdown option content — a TypeaheadSearchField's `renderOption` over
// `/api/items/` rows (useItemSuggestions), which name the SKU `shopify_sku`.
// Shopify → the shared image+name+SKU identity; other stores → text.
export function ItemOptionContent({ option, isShopify }) {
  if (!isShopify) {
    // Reuse the single-source-of-truth label so the dropdown text and the input
    // it commits to are identical (same LABEL_SEP), never a hand-kept duplicate.
    return <span className="item-option__text">{formatItemLabel(option, false)}</span>;
  }
  return (
    <ProductIdentity
      imageUrl={option.image_url}
      name={option.item_name}
      sku={option.shopify_sku}
    />
  );
}
